import React, { useEffect, useState } from "react";
import "./styles/MerchantScreen.css";
import { LinearGradient } from "react-text-gradients";
import SideBar from "../../Common/SideBar";
import { useDispatch, useSelector } from "react-redux";
import {
  collapseSidebar,
  expandSidebar,
} from "../../../store/reducers/sidebarSlice";
import Modal from "react-modal";
import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  onSnapshot,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "../../../config/firebase";
import { accountType, firestoreCollections } from "../../../utils";
import { errorToast, successToast } from "../../../services/toastService";
import { sendNotification } from "../../../services/firebaseService";
import { NavLink } from "react-router-dom";
import {
  useFetchAllMerchantsQuery,
  useFetchCustomerMerchantChatQuery,
} from "../../../services/baseQuery";
import { OvalLoader } from "../../Common/Loaders";

export default function AllMerchantScreen() {
  const sidebar = useSelector((state) => state.sidebar);
  const dispatch = useDispatch();
  const {
    isLoading,
    isError,
    data: allMerchants,
    error,
    isFetching,
  } = useFetchAllMerchantsQuery();

  const {
    isLoading: isChatLoading,
    isError: isChatError,
    data: chatData,
    error: chatError,
    isFetching: isChatFetching,
  } = useFetchCustomerMerchantChatQuery({
    merchantId: "VBUsBME5FcaFXvqO4VAJTHGhTz03",
    customerId: "IyePGOLYUnQZy4sdfplR4Yi7UBUQY02",
  });

  useEffect(() => {
    console.log("useeff run");
    if (chatData) console.log(chatData, "<<<< chat data");
    if (isChatError) console.log(chatError, "<<<< chat error");
  }, [isChatLoading]);

  // console.log(sidebar.expand, "<<< sidebar");

  // const fetchAllMerchants = () => {
  //   const q = query(
  //     collection(db, firestoreCollections.merchants),
  //     where("profileAdded", "==", true)
  //   );

  //   const unsubscribe = onSnapshot(q, async querySnapshot => {
  //     const newData = await Promise.all(
  //       querySnapshot.docs.map(async merchDoc => {
  //         const merchantData = merchDoc.data();
  //         merchantData.category = await Promise.all(
  //           merchantData.category.map(async categId => {
  //             const categoryDoc = await getDoc(
  //               doc(db, firestoreCollections.merchantCategories, categId)
  //             );
  //             if (categoryDoc.exists()) {
  //               const data = categoryDoc.data();
  //               data.id = categoryDoc.id;
  //               return data;
  //             }
  //           })
  //         );

  //         return {
  //           ...merchantData,
  //           id: merchDoc.id,
  //         };
  //       })
  //     );

  //     setAllRequests(newData);
  //     console.log(newData);
  //   });

  //   return unsubscribe; // Return the unsubscribe function to detach the listener when needed
  // };

  // useEffect(() => {
  //   const unsubscribe = fetchAllMerchants();

  //   return () => {
  //     unsubscribe(); // Detach the listener when the component unmounts
  //   };
  // }, []);

  return (
    <div className="MainContainer">
      <SideBar />
      <div
        style={{ width: sidebar.expand ? "84vw" : "95vw" }}
        className="ScreenContainer"
      >
        {/* upper search bar start */}

        <div className="upperSearchBarContainer">
          <div className="upperBarSearchBar">
            <div className="pageHeadingInnerContainer">
              {/* <img
                src={require("../../../assets/dashboardColourIcon.png")}
                alt="profile-pic"
                className="pageHeadingImageDashboard"
              /> */}
              <div className="pageHeading">All Merchant</div>
            </div>
          </div>

          <div
            className="upperBarSearchBox upperBarSearchBoxProfile"
            style={{ border: "none" }}
          >
            <img
              src={require("../../../assets/profile.png")}
              alt="profile-pic"
            />
          </div>
          <div className="upperBarSearchBox upperBarSearchBoxNotification">
            <img
              src={require("../../../assets/exit.png")}
              alt="notification-bell"
            />
          </div>
        </div>
        <div
          className="upperSearchBarContainer"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "1.5vh",
          }}
        >
          <input placeholder="Search..." className="upperBarSearchBarInput" />
          <div className="searchButton">Search</div>
        </div>
        <div className="verificationTableContainer">
          <div className="verificationTableRow">
            <div
              style={{ width: "10%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Sr. No.
            </div>
            <div
              style={{ width: "18.75%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Name
            </div>
            <div
              style={{ width: "18.75%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Phone Number
            </div>
            {/* <div
              style={{ width: "15%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Date Joined
            </div> */}
            <div
              style={{ width: "18.75%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Category
            </div>
            <div
              style={{ width: "18.75%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Email
            </div>
            <div
              style={{ width: "18.75%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Status
            </div>
            <div
              style={{ width: "15%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              View Profile
            </div>
          </div>
          {isLoading ? (
            <OvalLoader visible={true} color="#3366CC" />
          ) : (
            allMerchants.map((item, i) => (
              <div
                className="verificationTableRow"
                key={i}
                style={{
                  backgroundColor: i % 2 == 0 ? "#6b5acd0e" : "#6b5acd1d",
                }}
              >
                <div
                  style={{ width: "10%", height: "100%" }}
                  className="eachColumn eachTableBody"
                >
                  {i + 1}
                </div>
                <div
                  style={{
                    width: "18.75%",
                    height: "100%",
                    textDecoration: "underline",
                    whiteSpace: "nowrap",
                  }}
                  className="eachColumn eachTableBody"
                >
                  {item.displayName.slice(0, 19)}
                </div>
                <div
                  style={{ width: "18.75%", height: "100%" }}
                  className="eachColumn eachTableBody"
                >
                  {item.phoneNumber}
                </div>
                {/* <div
                style={{ width: "15%", height: "100%" }}
                className="eachColumn eachTableBody"
              >
                {item.dateJoined}
              </div> */}
                <div
                  style={{ width: "18.75%", height: "100%" }}
                  className="eachColumn eachTableBody"
                >
                  {item?.category[0].name}
                </div>

                <div
                  style={{ width: "18.75%", height: "100%" }}
                  className="eachColumn eachTableBody"
                >
                  {item.email}
                </div>
                <div
                  style={{ width: "18.75%", height: "100%" }}
                  className="eachColumn eachTableBody"
                >
                  {item.accountStatus.type || "-"}
                </div>
                <NavLink
                  to={`/allMerchants/${item.id}`}
                  style={{
                    width: "15%",
                    height: "100%",
                    textDecoration: "underline",
                    color: "#3366CC",
                  }}
                  className="eachColumn eachTableBody"
                >
                  View Profile
                </NavLink>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
